/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AttemptRefusalDto } from '../models';
// @ts-ignore
import type { ConflictProblemDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
// @ts-ignore
import type { SurveyAnswerDto } from '../models';
// @ts-ignore
import type { SurveyRefusalDto } from '../models';
// @ts-ignore
import type { SurveyResponseDetailsDto } from '../models';
// @ts-ignore
import type { SurveyResponseDto } from '../models';
// @ts-ignore
import type { SurveyResponsePageDto } from '../models';
// @ts-ignore
import type { SurveyResponseStartDto } from '../models';
// @ts-ignore
import type { SurveyResponseStartedDto } from '../models';
// @ts-ignore
import type { SurveyResponseStatusDto } from '../models';
/**
 * SurveyResponsesApi - axios parameter creator
 * @export
 */
export const SurveyResponsesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Saved at once. A single choice takes chosenAnswerIds with exactly one option; an open question takes typed, and typed blank takes the answer back — an open question needs none. There is no time limit.
         * @summary Answer a question, or change the answer
         * @param {string} responseId 
         * @param {number} index The place of the question in the response, counted from 1.
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {SurveyAnswerDto} surveyAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerSurveyQuestion: async (responseId: string, index: number, xResponseKey: string, surveyAnswerDto: SurveyAnswerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('answerSurveyQuestion', 'responseId', responseId)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('answerSurveyQuestion', 'index', index)
            // verify required parameter 'xResponseKey' is not null or undefined
            assertParamExists('answerSurveyQuestion', 'xResponseKey', xResponseKey)
            // verify required parameter 'surveyAnswerDto' is not null or undefined
            assertParamExists('answerSurveyQuestion', 'surveyAnswerDto', surveyAnswerDto)
            const localVarPath = `/api/v1/survey-responses/{responseId}/answers/{index}`
                .replace(`{${"responseId"}}`, encodeURIComponent(String(responseId)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xResponseKey != null) {
                localVarHeaderParameter['X-Response-Key'] = String(xResponseKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyAnswerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * While it is in progress: every question in the order of the survey, in the language of the response, with the answers in their fixed order, whether an answer is required, and what the person has answered so far. Pictures and films come as links that work for a few minutes; ask again for fresh ones. Once submitted or refused it carries no questions and no answers — the end screen shows none, and whoever stands next to the screen sees none.
         * @summary The response as the person filling it in sees it
         * @param {string} responseId 
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyResponse: async (responseId: string, xResponseKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('getSurveyResponse', 'responseId', responseId)
            // verify required parameter 'xResponseKey' is not null or undefined
            assertParamExists('getSurveyResponse', 'xResponseKey', xResponseKey)
            const localVarPath = `/api/v1/survey-responses/{responseId}`
                .replace(`{${"responseId"}}`, encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xResponseKey != null) {
                localVarHeaderParameter['X-Response-Key'] = String(xResponseKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A session opens this, not the key. For a named survey, every question as the person saw it — the version and the order of options — with the answer and when it was given. For an anonymous one, how the response ended and nothing of what was answered: answersShown is false and questions is empty.
         * @summary A response with its answers, for whoever runs the survey
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyResponseDetails: async (responseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('getSurveyResponseDetails', 'responseId', responseId)
            const localVarPath = `/api/v1/survey-responses/{responseId}/details`
                .replace(`{${"responseId"}}`, encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Newest first. A response shows its person and how it ended for an anonymous survey too — who filled it in is not anonymous, what they answered is. Opened with a session, never with the key of a response. For the administrator for now; scopes by shop and region come with permissions.
         * @summary Who filled in or refused which survey, for whoever runs them
         * @param {string} [surveyId] 
         * @param {string} [sapNumber] The person, by the SAP number exactly.
         * @param {SurveyResponseStatusDto} [status] 
         * @param {string} [startedFrom] Started on this day or later.
         * @param {string} [startedTo] Started on this day or earlier, the whole day counted.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyResponses: async (surveyId?: string, sapNumber?: string, status?: SurveyResponseStatusDto, startedFrom?: string, startedTo?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surveyId !== undefined) {
                localVarQueryParameter['surveyId'] = surveyId;
            }

            if (sapNumber !== undefined) {
                localVarQueryParameter['sapNumber'] = sapNumber;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (startedFrom !== undefined) {
                localVarQueryParameter['startedFrom'] = (startedFrom as any instanceof Date) ?
                    (startedFrom as any).toISOString().substring(0,10) :
                    startedFrom;
            }

            if (startedTo !== undefined) {
                localVarQueryParameter['startedTo'] = (startedTo as any instanceof Date) ?
                    (startedTo as any).toISOString().substring(0,10) :
                    startedTo;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Filling a survey in is not obligatory. A refusal is recorded with the person; the answers given so far are dropped, and the response shows whether it was refused at the start or broken off. A response already refused comes back as it is.
         * @summary Refuse the survey, before it starts or halfway
         * @param {string} responseId 
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refuseSurveyResponse: async (responseId: string, xResponseKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('refuseSurveyResponse', 'responseId', responseId)
            // verify required parameter 'xResponseKey' is not null or undefined
            assertParamExists('refuseSurveyResponse', 'xResponseKey', xResponseKey)
            const localVarPath = `/api/v1/survey-responses/{responseId}/refuse`
                .replace(`{${"responseId"}}`, encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xResponseKey != null) {
                localVarHeaderParameter['X-Response-Key'] = String(xResponseKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Started from the panel by whoever runs the survey — an administrator for now, a manager in the shop later. The person filling it in does not sign in: the answer carries a key, once, and the screen of the survey sends it with every call that follows. The questions are the survey\'s for every position and for the person\'s own, in the order of the survey, each with its version in force and its answers in their fixed order — as the preview shows them. They are kept as they are now: a later change to the survey or the bank touches no response. Whether the survey is anonymous is kept with the response too.
         * @summary Start a response to an active survey for a named person
         * @param {string} surveyId 
         * @param {SurveyResponseStartDto} surveyResponseStartDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSurveyResponse: async (surveyId: string, surveyResponseStartDto: SurveyResponseStartDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('startSurveyResponse', 'surveyId', surveyId)
            // verify required parameter 'surveyResponseStartDto' is not null or undefined
            assertParamExists('startSurveyResponse', 'surveyResponseStartDto', surveyResponseStartDto)
            const localVarPath = `/api/v1/surveys/{surveyId}/responses`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyResponseStartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only with every required question answered — the questions to choose in; an open one may stay empty. A response already submitted comes back as it is.
         * @summary Submit the response
         * @param {string} responseId 
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSurveyResponse: async (responseId: string, xResponseKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('submitSurveyResponse', 'responseId', responseId)
            // verify required parameter 'xResponseKey' is not null or undefined
            assertParamExists('submitSurveyResponse', 'xResponseKey', xResponseKey)
            const localVarPath = `/api/v1/survey-responses/{responseId}/submit`
                .replace(`{${"responseId"}}`, encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xResponseKey != null) {
                localVarHeaderParameter['X-Response-Key'] = String(xResponseKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyResponsesApi - functional programming interface
 * @export
 */
export const SurveyResponsesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyResponsesApiAxiosParamCreator(configuration)
    return {
        /**
         * Saved at once. A single choice takes chosenAnswerIds with exactly one option; an open question takes typed, and typed blank takes the answer back — an open question needs none. There is no time limit.
         * @summary Answer a question, or change the answer
         * @param {string} responseId 
         * @param {number} index The place of the question in the response, counted from 1.
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {SurveyAnswerDto} surveyAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerSurveyQuestion(responseId: string, index: number, xResponseKey: string, surveyAnswerDto: SurveyAnswerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerSurveyQuestion(responseId, index, xResponseKey, surveyAnswerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyResponsesApi.answerSurveyQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * While it is in progress: every question in the order of the survey, in the language of the response, with the answers in their fixed order, whether an answer is required, and what the person has answered so far. Pictures and films come as links that work for a few minutes; ask again for fresh ones. Once submitted or refused it carries no questions and no answers — the end screen shows none, and whoever stands next to the screen sees none.
         * @summary The response as the person filling it in sees it
         * @param {string} responseId 
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyResponse(responseId, xResponseKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyResponsesApi.getSurveyResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A session opens this, not the key. For a named survey, every question as the person saw it — the version and the order of options — with the answer and when it was given. For an anonymous one, how the response ended and nothing of what was answered: answersShown is false and questions is empty.
         * @summary A response with its answers, for whoever runs the survey
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyResponseDetails(responseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponseDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyResponseDetails(responseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyResponsesApi.getSurveyResponseDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Newest first. A response shows its person and how it ended for an anonymous survey too — who filled it in is not anonymous, what they answered is. Opened with a session, never with the key of a response. For the administrator for now; scopes by shop and region come with permissions.
         * @summary Who filled in or refused which survey, for whoever runs them
         * @param {string} [surveyId] 
         * @param {string} [sapNumber] The person, by the SAP number exactly.
         * @param {SurveyResponseStatusDto} [status] 
         * @param {string} [startedFrom] Started on this day or later.
         * @param {string} [startedTo] Started on this day or earlier, the whole day counted.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSurveyResponses(surveyId?: string, sapNumber?: string, status?: SurveyResponseStatusDto, startedFrom?: string, startedTo?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponsePageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSurveyResponses(surveyId, sapNumber, status, startedFrom, startedTo, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyResponsesApi.listSurveyResponses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Filling a survey in is not obligatory. A refusal is recorded with the person; the answers given so far are dropped, and the response shows whether it was refused at the start or broken off. A response already refused comes back as it is.
         * @summary Refuse the survey, before it starts or halfway
         * @param {string} responseId 
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refuseSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refuseSurveyResponse(responseId, xResponseKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyResponsesApi.refuseSurveyResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Started from the panel by whoever runs the survey — an administrator for now, a manager in the shop later. The person filling it in does not sign in: the answer carries a key, once, and the screen of the survey sends it with every call that follows. The questions are the survey\'s for every position and for the person\'s own, in the order of the survey, each with its version in force and its answers in their fixed order — as the preview shows them. They are kept as they are now: a later change to the survey or the bank touches no response. Whether the survey is anonymous is kept with the response too.
         * @summary Start a response to an active survey for a named person
         * @param {string} surveyId 
         * @param {SurveyResponseStartDto} surveyResponseStartDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startSurveyResponse(surveyId: string, surveyResponseStartDto: SurveyResponseStartDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponseStartedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startSurveyResponse(surveyId, surveyResponseStartDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyResponsesApi.startSurveyResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only with every required question answered — the questions to choose in; an open one may stay empty. A response already submitted comes back as it is.
         * @summary Submit the response
         * @param {string} responseId 
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitSurveyResponse(responseId, xResponseKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyResponsesApi.submitSurveyResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyResponsesApi - factory interface
 * @export
 */
export const SurveyResponsesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyResponsesApiFp(configuration)
    return {
        /**
         * Saved at once. A single choice takes chosenAnswerIds with exactly one option; an open question takes typed, and typed blank takes the answer back — an open question needs none. There is no time limit.
         * @summary Answer a question, or change the answer
         * @param {string} responseId 
         * @param {number} index The place of the question in the response, counted from 1.
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {SurveyAnswerDto} surveyAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerSurveyQuestion(responseId: string, index: number, xResponseKey: string, surveyAnswerDto: SurveyAnswerDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.answerSurveyQuestion(responseId, index, xResponseKey, surveyAnswerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * While it is in progress: every question in the order of the survey, in the language of the response, with the answers in their fixed order, whether an answer is required, and what the person has answered so far. Pictures and films come as links that work for a few minutes; ask again for fresh ones. Once submitted or refused it carries no questions and no answers — the end screen shows none, and whoever stands next to the screen sees none.
         * @summary The response as the person filling it in sees it
         * @param {string} responseId 
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseDto> {
            return localVarFp.getSurveyResponse(responseId, xResponseKey, options).then((request) => request(axios, basePath));
        },
        /**
         * A session opens this, not the key. For a named survey, every question as the person saw it — the version and the order of options — with the answer and when it was given. For an anonymous one, how the response ended and nothing of what was answered: answersShown is false and questions is empty.
         * @summary A response with its answers, for whoever runs the survey
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyResponseDetails(responseId: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseDetailsDto> {
            return localVarFp.getSurveyResponseDetails(responseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Newest first. A response shows its person and how it ended for an anonymous survey too — who filled it in is not anonymous, what they answered is. Opened with a session, never with the key of a response. For the administrator for now; scopes by shop and region come with permissions.
         * @summary Who filled in or refused which survey, for whoever runs them
         * @param {string} [surveyId] 
         * @param {string} [sapNumber] The person, by the SAP number exactly.
         * @param {SurveyResponseStatusDto} [status] 
         * @param {string} [startedFrom] Started on this day or later.
         * @param {string} [startedTo] Started on this day or earlier, the whole day counted.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyResponses(surveyId?: string, sapNumber?: string, status?: SurveyResponseStatusDto, startedFrom?: string, startedTo?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponsePageDto> {
            return localVarFp.listSurveyResponses(surveyId, sapNumber, status, startedFrom, startedTo, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Filling a survey in is not obligatory. A refusal is recorded with the person; the answers given so far are dropped, and the response shows whether it was refused at the start or broken off. A response already refused comes back as it is.
         * @summary Refuse the survey, before it starts or halfway
         * @param {string} responseId 
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refuseSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseDto> {
            return localVarFp.refuseSurveyResponse(responseId, xResponseKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Started from the panel by whoever runs the survey — an administrator for now, a manager in the shop later. The person filling it in does not sign in: the answer carries a key, once, and the screen of the survey sends it with every call that follows. The questions are the survey\'s for every position and for the person\'s own, in the order of the survey, each with its version in force and its answers in their fixed order — as the preview shows them. They are kept as they are now: a later change to the survey or the bank touches no response. Whether the survey is anonymous is kept with the response too.
         * @summary Start a response to an active survey for a named person
         * @param {string} surveyId 
         * @param {SurveyResponseStartDto} surveyResponseStartDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSurveyResponse(surveyId: string, surveyResponseStartDto: SurveyResponseStartDto, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseStartedDto> {
            return localVarFp.startSurveyResponse(surveyId, surveyResponseStartDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Only with every required question answered — the questions to choose in; an open one may stay empty. A response already submitted comes back as it is.
         * @summary Submit the response
         * @param {string} responseId 
         * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseDto> {
            return localVarFp.submitSurveyResponse(responseId, xResponseKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveyResponsesApi - interface
 * @export
 * @interface SurveyResponsesApi
 */
export interface SurveyResponsesApiInterface {
    /**
     * Saved at once. A single choice takes chosenAnswerIds with exactly one option; an open question takes typed, and typed blank takes the answer back — an open question needs none. There is no time limit.
     * @summary Answer a question, or change the answer
     * @param {string} responseId 
     * @param {number} index The place of the question in the response, counted from 1.
     * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
     * @param {SurveyAnswerDto} surveyAnswerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApiInterface
     */
    answerSurveyQuestion(responseId: string, index: number, xResponseKey: string, surveyAnswerDto: SurveyAnswerDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * While it is in progress: every question in the order of the survey, in the language of the response, with the answers in their fixed order, whether an answer is required, and what the person has answered so far. Pictures and films come as links that work for a few minutes; ask again for fresh ones. Once submitted or refused it carries no questions and no answers — the end screen shows none, and whoever stands next to the screen sees none.
     * @summary The response as the person filling it in sees it
     * @param {string} responseId 
     * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApiInterface
     */
    getSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseDto>;

    /**
     * A session opens this, not the key. For a named survey, every question as the person saw it — the version and the order of options — with the answer and when it was given. For an anonymous one, how the response ended and nothing of what was answered: answersShown is false and questions is empty.
     * @summary A response with its answers, for whoever runs the survey
     * @param {string} responseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApiInterface
     */
    getSurveyResponseDetails(responseId: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseDetailsDto>;

    /**
     * Newest first. A response shows its person and how it ended for an anonymous survey too — who filled it in is not anonymous, what they answered is. Opened with a session, never with the key of a response. For the administrator for now; scopes by shop and region come with permissions.
     * @summary Who filled in or refused which survey, for whoever runs them
     * @param {string} [surveyId] 
     * @param {string} [sapNumber] The person, by the SAP number exactly.
     * @param {SurveyResponseStatusDto} [status] 
     * @param {string} [startedFrom] Started on this day or later.
     * @param {string} [startedTo] Started on this day or earlier, the whole day counted.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApiInterface
     */
    listSurveyResponses(surveyId?: string, sapNumber?: string, status?: SurveyResponseStatusDto, startedFrom?: string, startedTo?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponsePageDto>;

    /**
     * Filling a survey in is not obligatory. A refusal is recorded with the person; the answers given so far are dropped, and the response shows whether it was refused at the start or broken off. A response already refused comes back as it is.
     * @summary Refuse the survey, before it starts or halfway
     * @param {string} responseId 
     * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApiInterface
     */
    refuseSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseDto>;

    /**
     * Started from the panel by whoever runs the survey — an administrator for now, a manager in the shop later. The person filling it in does not sign in: the answer carries a key, once, and the screen of the survey sends it with every call that follows. The questions are the survey\'s for every position and for the person\'s own, in the order of the survey, each with its version in force and its answers in their fixed order — as the preview shows them. They are kept as they are now: a later change to the survey or the bank touches no response. Whether the survey is anonymous is kept with the response too.
     * @summary Start a response to an active survey for a named person
     * @param {string} surveyId 
     * @param {SurveyResponseStartDto} surveyResponseStartDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApiInterface
     */
    startSurveyResponse(surveyId: string, surveyResponseStartDto: SurveyResponseStartDto, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseStartedDto>;

    /**
     * Only with every required question answered — the questions to choose in; an open one may stay empty. A response already submitted comes back as it is.
     * @summary Submit the response
     * @param {string} responseId 
     * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApiInterface
     */
    submitSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseDto>;

}

/**
 * SurveyResponsesApi - object-oriented interface
 * @export
 * @class SurveyResponsesApi
 * @extends {BaseAPI}
 */
export class SurveyResponsesApi extends BaseAPI implements SurveyResponsesApiInterface {
    /**
     * Saved at once. A single choice takes chosenAnswerIds with exactly one option; an open question takes typed, and typed blank takes the answer back — an open question needs none. There is no time limit.
     * @summary Answer a question, or change the answer
     * @param {string} responseId 
     * @param {number} index The place of the question in the response, counted from 1.
     * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
     * @param {SurveyAnswerDto} surveyAnswerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApi
     */
    public answerSurveyQuestion(responseId: string, index: number, xResponseKey: string, surveyAnswerDto: SurveyAnswerDto, options?: RawAxiosRequestConfig) {
        return SurveyResponsesApiFp(this.configuration).answerSurveyQuestion(responseId, index, xResponseKey, surveyAnswerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * While it is in progress: every question in the order of the survey, in the language of the response, with the answers in their fixed order, whether an answer is required, and what the person has answered so far. Pictures and films come as links that work for a few minutes; ask again for fresh ones. Once submitted or refused it carries no questions and no answers — the end screen shows none, and whoever stands next to the screen sees none.
     * @summary The response as the person filling it in sees it
     * @param {string} responseId 
     * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApi
     */
    public getSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig) {
        return SurveyResponsesApiFp(this.configuration).getSurveyResponse(responseId, xResponseKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A session opens this, not the key. For a named survey, every question as the person saw it — the version and the order of options — with the answer and when it was given. For an anonymous one, how the response ended and nothing of what was answered: answersShown is false and questions is empty.
     * @summary A response with its answers, for whoever runs the survey
     * @param {string} responseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApi
     */
    public getSurveyResponseDetails(responseId: string, options?: RawAxiosRequestConfig) {
        return SurveyResponsesApiFp(this.configuration).getSurveyResponseDetails(responseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Newest first. A response shows its person and how it ended for an anonymous survey too — who filled it in is not anonymous, what they answered is. Opened with a session, never with the key of a response. For the administrator for now; scopes by shop and region come with permissions.
     * @summary Who filled in or refused which survey, for whoever runs them
     * @param {string} [surveyId] 
     * @param {string} [sapNumber] The person, by the SAP number exactly.
     * @param {SurveyResponseStatusDto} [status] 
     * @param {string} [startedFrom] Started on this day or later.
     * @param {string} [startedTo] Started on this day or earlier, the whole day counted.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApi
     */
    public listSurveyResponses(surveyId?: string, sapNumber?: string, status?: SurveyResponseStatusDto, startedFrom?: string, startedTo?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return SurveyResponsesApiFp(this.configuration).listSurveyResponses(surveyId, sapNumber, status, startedFrom, startedTo, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Filling a survey in is not obligatory. A refusal is recorded with the person; the answers given so far are dropped, and the response shows whether it was refused at the start or broken off. A response already refused comes back as it is.
     * @summary Refuse the survey, before it starts or halfway
     * @param {string} responseId 
     * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApi
     */
    public refuseSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig) {
        return SurveyResponsesApiFp(this.configuration).refuseSurveyResponse(responseId, xResponseKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Started from the panel by whoever runs the survey — an administrator for now, a manager in the shop later. The person filling it in does not sign in: the answer carries a key, once, and the screen of the survey sends it with every call that follows. The questions are the survey\'s for every position and for the person\'s own, in the order of the survey, each with its version in force and its answers in their fixed order — as the preview shows them. They are kept as they are now: a later change to the survey or the bank touches no response. Whether the survey is anonymous is kept with the response too.
     * @summary Start a response to an active survey for a named person
     * @param {string} surveyId 
     * @param {SurveyResponseStartDto} surveyResponseStartDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApi
     */
    public startSurveyResponse(surveyId: string, surveyResponseStartDto: SurveyResponseStartDto, options?: RawAxiosRequestConfig) {
        return SurveyResponsesApiFp(this.configuration).startSurveyResponse(surveyId, surveyResponseStartDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only with every required question answered — the questions to choose in; an open one may stay empty. A response already submitted comes back as it is.
     * @summary Submit the response
     * @param {string} responseId 
     * @param {string} xResponseKey The key the start of the response answered with. It opens this response and nothing else; the person filling the survey in has no session. Sent in a header, never in an address.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyResponsesApi
     */
    public submitSurveyResponse(responseId: string, xResponseKey: string, options?: RawAxiosRequestConfig) {
        return SurveyResponsesApiFp(this.configuration).submitSurveyResponse(responseId, xResponseKey, options).then((request) => request(this.axios, this.basePath));
    }
}

